export default class TokenService {
  constructor(oauthConfig, $httpParamSerializer) {
    "ngInject";
    this.config = oauthConfig;
    this.paramSerializer = $httpParamSerializer;
    this.decodedUsername = null;
  }

  setToken(token) {
    this.token = token
  }
  
  getToken(token) {
    return this.token
  }

  setDecodedUsername(username) {
    this.decodedUsername = username;
  }

  getDecodedUsername() {
    return this.decodedUsername;
  }
  
  getLoginEndpoint() {
    const server = this.config.authentificationServer;
    const params = this.paramSerializer({
      response_type: 'token',
      client_id:     this.config.CLIENT_ID,
      redirect_uri:  this.config.login_callback_url,
      scope: '',
      state: ''
    });
    return `${server}/oauth/authorize?${params}`
  }
  
  getLogoutEndpoint() {
    const server = this.config.authentificationServer;
    const params = this.paramSerializer({
      redirecturl: this.config.logout_callback_url
    });
    return `${server}/logout?${params}`
  }
}



// WEBPACK FOOTER //
// ./src/services/token.service.js